<template>
    <div class="d-flex flex-column custom-gap">
        <EventEntryMain
            v-for="event in events"
            :key="event.id"
            :event="event"
            :i-frame-type="iFrameType"
            :expanded-by-default="extendedByDefault"
            :hide-categories="hideCategories" />
        <div
            v-for="n in showNumberOfLoadingEntries"
            :key="n">
            <EventEntryLoadingDummy />
        </div>
    </div>
</template>

<script>
import EventEntryMain from "@/components/pages/eventIFrame/EventEntry/EventEntryMain";
import EventEntryLoadingDummy
    from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryLoadingDummy";

export default {
    name: "IFrameEventListing",
    components: {EventEntryLoadingDummy, EventEntryMain},
    props: {
        events: {
            type: Array,
            required: true
        },
        iFrameType: {
            type: String,
            required: true
        },
        showNumberOfLoadingEntries: {
            type: Number,
            default: 0
        },
        displayCollapsed: {
            type: String,
            default: 'automatic'
        },
        showingSingleEvent: {
            type: Boolean,
            default: false
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        extendedByDefault() {
            switch (this.displayCollapsed) {
                case 'all':
                    return false
                case 'none':
                    return true
                default:
                    return this.events.length === 1
            }
        }
    },
    mounted() {
        this.$emit('hook:mounted')
    }
}
</script>

<style scoped>
.custom-gap {
    gap: 2.5rem
}
</style>
